<template>
  <div class="verfif" v-if="VAQdialogVisible">
    <el-dialog
      class="noPaddingDialog"
      width="50%"
      v-model="VAQview"
      :show-close="false"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal="false"
      append-to-body
      v-if="VAQview"
      :style="{visibility: isAppenInput ? 'visible' : 'hidden'}"
    >
      <!-- :append-to-body="true"  -->
      <div class="verfif-close" @click="handleClose()">
        <el-icon><Close /></el-icon>
      </div>
      <el-scrollbar class="el-menu-scrollbar__wrap wisdomSubmit">
        <!-- <div class="wisdomSubmit"> -->
        <el-scrollbar
          class="el-menu-scrollbar__wrap inputBox max-box-1200"
          v-loading="fullScreenLoading"
          element-loading-text="数据加载中"
        >
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            :label-position="'top'"
            class="form-class"
            @submit.prevent
          >
            <widget-one-layer
              v-model:ruleListChild="ruleList"
              v-model:ctoArrayChild="ctoArray"
              :isInput="isInput"
              :formdata="formdata"
              ref="widgetOneLayerRef"
              @widgetOneLayerEmit="widgetOneLayerEmitFun"
            >
              <el-col :span="12" v-if="iscustom == 1">
                <el-form-item
                  label="标题"
                  prop="appname"
                  :rules="[{ required: true, trigger: 'false' }]"
                >
                  <el-input
                    v-model="appname"
                    class="input-details"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
            </widget-one-layer>
          </el-form>
        </el-scrollbar>
        <!-- </div> -->
      </el-scrollbar>
      <div class="wisdomSubmitBox" v-if="!this.$route.query.fromset">
        <!--this.$route.query.fromset来源模板安装预览，不要提交-->
        <div class="footer">
          <div>
            <el-button
              type="yeprimary"
              v-if="prevShow"
              @click="showList(isNameCto, true)"
              :disabled="linkageLoading"
            >
              上一步
            </el-button>
            <el-button
              type="yeprimary"
              @click="submitForm('ruleForm')"
              :disabled="linkageLoading"
            >
              下一步
            </el-button>
          </div>
        </div>
      </div>
      <multipleChoice
        ref="multipleChoiceChild"
        v-on:fromMultipleChoice="fromMultipleChoice"
      ></multipleChoice>
      <levelSelect
        ref="levelSelectRef"
        v-on:fromLevelSelect="levelSelectMethod"
      ></levelSelect>
    </el-dialog>
    <div class="verifi-div" v-show="!VAQview">
      <img
        src="https://bigdata.topeti.com/PCRepository/defaultSvg/NoTask.svg"
        class="verifi-img"
      />
      <div class="verifi-text">本应用需验证后才能访问</div>
      <div class="verifi-button" @click="beginVertical">开始验证</div>
    </div>
    <verificationSelect
      ref="verificationSelectRef"
      :approvalId="$route.query.approvalId || approvalId"
      @VerificationSelectEmit="handleVerificationSelect"
    />
    <upIphone ref="upIphones" @yesRetIphone="retUpIphone" />
  </div>
</template>
<!---需要嵌入这个模块，一定需要给个固定大小的区域来并且position:absolute 或者relative-->
<script>
  import { validateapprovaldashboarddata, validatedata } from '@/port/clientSide/workbench'
  import multipleChoice from '../common/multipleChoice.vue';
  import levelSelect from '../common/levelSelect.vue';//自由选择
  import widgetOneLayer from './formFillinPageChild/widgetOneLayer'
  import upIphone from '@/components/common/upIphone.vue'
  import verificationSelect from './workbench/verificationSelect/index.vue'
  import { momVal } from '@/api/utils'
  export default {
    name: 'VerificationAndQueryInput',
    props:['approvalId','number'],//number:0发起，1个人数据，2全校数据，4仪表盘验证
    components: {
      multipleChoice,
      levelSelect,
      widgetOneLayer,
      upIphone,
      verificationSelect
    },
    data() {
      return {
        VAQview: false, // 验证弹出是否打开
        VAQdialogVisible:false, // 整体框弹出关闭
        appname: '',
        fullScreenLoading: false,
        iscustom: 0,//自定义标题//1自定义0非自定义
        ruleList: [],//控件数据
        ruleForm: {},
        ctoArray: null,
        itemKey: null,
        upDataFileState:true,//图片附件上传状态如上传完成与否true为成功
        isInput:1,//1为发起，2为暂存
        formdata: null, // 值合集
        isNameCto: null,//- 验证批量数据模型
        linkageLoading:false,//跑联动的时候加载效果使用
        validatequery:true,
        appid: 0,
        isVerifictionIphone: false ,  // 是否需要验证手机号
        prevShow: true, //上一步按钮显示/隐藏
        isAppenInput: true
      }
    },
    methods: {
      // 关闭时更新上一级class 主要给 applicationRouting 文件使用
      handleClose () {
        this.VAQview = false
        try {
          // 当前这个主要供给 applicationRouting 文件，其他有问题再说
          if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.showModal) {
            this.$parent.$parent.$parent.isInput = false
            this.$parent.$parent.$parent.showModal = false
          }
        } catch (err) { console.log(err) }
      },
      // 打开绑定手机窗口
      onUpIphone () {
        let val = {
          title: '绑定手机',
          bottom: '确定绑定',
          origin: 'user'
        };
        console.log('帮i的那个', this.$refs);
        this.$refs.upIphones.showDialog(val);
      },
      // 手机绑定窗口返回
      retUpIphone() {
        console.log('手机绑定窗口返回')
      },
      // 需要绑定手机号提示
      iphoneBind() {
        this.VAQdialogVisible = true;
        let self = this;
        this.$confirm('本操作需要短信验证，您尚未绑定手机，是否先去绑定？', '提示', {
          confirmButtonClass:'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.onUpIphone();
        }).catch(() => {

        });
      },

      goback(item) {
        this.$confirm('返回后本页面填写的数据将不保存。确定返回？', '提示', {
          confirmButtonClass:'el-button--yeprimary',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.go(item)
        }).catch(() => {
        });
      },
      //- 提交
      submitForm() {
        if(this.upDataFileState.type&&!this.upDataFileState.upDataFile){
          this.$message.error('请等待图片附加上传完毕后再提交！');
          return false;
        }
        //修改没有自定义标题
        if (this.iscustom == 1 && this.appname == '') {
          this.$message.error('自定义标题不能为空');
          return;
        }
        if (this.iscustom == 1) {
          this.$set(this.ruleForm, 'appname', this.appname);
        }
        const ruleLisTparam = this.$refs.widgetOneLayerRef.widgetOneLayerPullData(1);
        console.log(ruleLisTparam,'ruleLisTparam');
        
        if (ruleLisTparam.isCheck == 2) {
          this.isAppenInput = true
          return false;
        }
        let dataList = JSON.parse(JSON.stringify(ruleLisTparam.dataList));
        let querys={};
        if(this.number!=0){//如果不是表单发起就需要处理
          let verificationData = {};
          this.ruleList.forEach(item =>{
            if(item.restore==0){//0过滤 1验证 2验证并过滤
              querys[item.title+'_'+item.type]=dataList[item.title+'_'+item.type]
            }else if(item.restore==1){
              verificationData[item.title+'_'+item.type] = dataList[item.title+'_'+item.type]
            }else{
              querys[item.title+'_'+item.type]=dataList[item.title+'_'+item.type]
              verificationData[item.title+'_'+item.type] = dataList[item.title+'_'+item.type]
            }
          })
          dataList = verificationData
        }
        //以下只作数据提交。不做数据逻辑。处理逻辑请到对于的

        dataList.number = this.number
        // 关闭回抛条件
        if(!this.validatequery){
          this.VAQdialogVisible=false;
          this.$emit('toVerificationAndQuery',{querys:JSON.stringify(querys)});
          return
        }
        this.fullScreenLoading = true;
        if(this.number == 4){
          //- 仪表盘验证提交模式
          dataList.approvalDashboardId = this.approvalId;
          validateapprovaldashboarddata(dataList).then(res => {
            this.fullScreenLoading = false;
            if (res.code === 0) {
              delete dataList.approvalId
              delete dataList.number
              this.$emit('toVerificationAndQuery',{querys:JSON.stringify(querys),dataList:dataList});
              this.VAQdialogVisible=false;              
              this.$message({
                  type: "success",
                  message: '验证成功!'
                });
            } else {
              this.$message.error(res.msg);
            }
          }).catch(() => {
            this.fullScreenLoading = false;
          })
        }else{
          dataList.approvalId = this.$route.query.approvalId||this.approvalId;
          dataList.appid = this.appid
          //- 表单验证提交模式
          validatedata(dataList).then(res => {
            this.fullScreenLoading = false;
            if (res.code === 0) {
              delete dataList.approvalId
              delete dataList.number
              this.$emit('toVerificationAndQuery',{querys:JSON.stringify(querys),dataList:dataList});
              this.VAQdialogVisible=false;
              this.$message({
                  type: "success",
                  message: '验证成功!'
                });
            } else {
              this.$message.error(res.msg);
              this.isAppenInput = true
            }
          }).catch(() => {
            this.fullScreenLoading = false;
          })
        }
      },
      fromMultipleChoice(param) {//来源multipleChoice.vue的方法
        let list = {organizationids:[]};
        if (param.checkedFlowArr) {
          list.organizationidArr = param.checkedFlowArr;
          param.checkedFlowArr.forEach(element => {
            list.organizationids.push(element.organizationId)
          });
        }
        if (param.checkedRoleArr) {
          list.roleids = []
          param.checkedRoleArr.forEach(el => {//过滤掉el.listpermission。看着烦。一坨的不知数据
            list.roleids.push(el.roleId)
            if (el.listpermission) {
              delete el.listpermission
            }
          });
          list.roleidArr = param.checkedRoleArr;
        }
        if (param.checkedUserArr) {
          var userArrList = [];
          param.checkedUserArr.forEach(el => {
            userArrList.push({name: el.realname, userId: el.userId,orgname: el.orgname})
          });
          list.user = userArrList;
        }
      },
      changeUser(item) {
        if (item.errorMsg) {
          delete item.errorMsg
        }
        var radioUser = false;
        if (item.freestyle == 1) {
          radioUser = true;
        }
        this.itemKey = item
        this.$refs.levelSelectRef.levelSelectChild({
          checkedList: item.user1,
          checkedFlow: item.user,
          radioUser: radioUser
        });
      },
      levelSelectMethod(param) {//自由选择返回
        this.itemKey.user = param
      },
      widgetOneLayerEmitFun(res){
        //res.type=1== 1是流程分条件第一层。4图片附件上传状态如上传完成与否,6是批量连联动加载表现linkageLoading使用，
        if(res.type == 4){
          this.upDataFileState = res;
        }else if (res.type == 6){
          this.linkageLoading = res.linkageLoading
        }else {
          console.log('确认为什么会走这个')
        }
      },
      //- 仪表盘·获取列表
      instrumentList(res) {
        if (res.data.isDirectlyEnter) {
          this.isAppenInput = false
        }
        this.validatequery = res.data.validatequery
        this.VAQdialogVisible = true;
        this.VAQview = true;
        this.prevShow=false;
        this.appname = "仪表盘验证"
        // 结果集的字典结构

        this.ruleList = JSON.parse(res.data.property||'[]')
        this.formdata = momVal(JSON.parse(res.data.property||'[]'));
        setTimeout(async () => {
          await this.$refs.widgetOneLayerRef.linkageInitiali(-1);
          if (res.data.isDirectlyEnter) {
            this.submitForm('ruleForm')
          }
        }, 500)
      },
      //- 表单·获取列表
      showList(ret,prve){
        this.isNameCto = ret
        this.VAQdialogVisible = true;
        const property = ret.data.property
        const defaultId = ret.data.default
        if (property.length===1 && !prve) { // 如果只有一项或者有默认值
          this.handleVerificationSelect(property[0])
          this.prevShow = false
        } else if (defaultId && !prve){
          let pro = property.find(item => {return item.appid === Number(defaultId)})
          if (pro) {
            this.handleVerificationSelect(pro)
          } else {
            this.$nextTick(()=>{
              this.$refs.verificationSelectRef.vsMethods(property, Number(defaultId))
            })
          }
        } else { // 如果多项，需要手动选择角色
          this.$nextTick(()=>{
            this.$refs.verificationSelectRef.vsMethods(property, Number(defaultId))
          })
        }
      },
      // 验证关闭重新打开验证
      beginVertical(){
        if (this.isNameCto) {
          this.showList(this.isNameCto)
        } else {
          this.VAQview = true
        }
      },
      async handleVerificationSelect(res) {
        if (res.isDirectlyEnter) {
          this.isAppenInput = false
        }
        this.appid = res.appid
        this.VAQview = true;
        this.validatequery = res.validatequery
        this.iscustom = res.iscustom
        if(this.iscustom==1){
          this.appname = res.title||""
        }
        // 结果集的字典结构
        this.ruleList = JSON.parse(res.property||'[]')
        this.formdata = momVal(JSON.parse(res.property||'[]'))
        setTimeout(async () => {
          await this.$refs.widgetOneLayerRef.linkageInitiali(-1)
          if (res.isDirectlyEnter) {
            this.submitForm('ruleForm')
          }
        }, 500)
      }
    },
    mounted() {
      // if(this.number == 4){
      //   //- 仪表盘验证
      //   this.instrumentList();
      // }else{
      //   //- 表单验证
      //   this.getsubmitformlist();

      // }

    },
    unmounted () {

    }
  }
</script>
<style lang="scss">
@import "~@/assets/style/oaExamineInputWidget";
.timeline-blue .el-timeline-item__icon {
  color: #3aa7e1;
}
.timeline-green .el-timeline-item__icon {
  color: #3faf67;
}
.timeline-add .el-timeline-item__icon {
  color: #4284ba;
}
.timeline-class .el-timeline-item__tail {
  top: 15px;
}
.timeline-class .el-timeline-item__node {
  top: 15px;
}
.verfif,
.verifi-div {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.verifi-div {
  // display: flex;
  // flex-direction: column;
  overflow: auto;
  text-align: center;
  padding-top: 10.24vh;
  box-sizing: border-box;
  // height: calc(100% - 18.24vh);
}
.verifi-img {
  width: 26.67vw;
  height: 30.19vh;
  display: block;
  margin: 0 auto 0 auto;
}
.verifi-text {
  font-size: 32px;
  color: rgba(39, 127, 217, 1);
  // padding-top: 6.39%;
  // padding-bottom: 4.63%;
  padding: 2% 0;
}
.verifi-button {
  width: 116px;
  height: 38px;
  line-height: 38px;
  color: #fff;
  text-align: center;
  background: #4e86ff;
  border-radius: 2px;
  font-size: 16px;
  // color: $base-white-color;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}
.verifi-button:active {
  background: #71b7ff;
}
.verfif-close {
  position: absolute;
  right: 20px;
  top: 10px;
  z-index: 1;
  display: inline-block;
  cursor: pointer;
  font-size: 24px;
}
</style>
<style lang="scss" scoped>
.wisdomSubmit {
  margin-bottom: 70px;
  height: 500px;
}
.wisdomSubmitBox {
  height: 56px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 111;
}
.wisdomSubmitBox .footer {
  max-width: 1200px;
  margin: 0 AUTO;
  height: 56px;
  padding: 0;
  background: #fff;
  box-shadow: 0px 0px 4px 0px RGBA(189, 189, 189, 0.5);
  overflow: hidden;
}
.wisdomSubmitBox .footer > div {
  float: right;
  padding-right: 20px;
  padding-top: 10px;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-row-input-title {
  padding: 0;
  margin: 24px 0 0 0;
}

.el-row-input-title .title {
  line-height: 50px;
}

.input-box {
  margin-bottom: 20px;
}

.uploadBtn {
  border: 1px solid #ccc;
  width: 90px;
  background: #fafafa;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  color: #666;
}
.inputBox {
  height: 100%;
}

.details-main:first-child {
  border-top: 1px solid #ddd;
}

.details-main {
  padding: 15px 10px;
  border-bottom: 1px solid #ddd;
}

.color-blue {
  color: #3a8ee6;
  border-color: #3a8ee6;
  float: right;
}

.details-title {
  margin-bottom: 15px;
}

.details-title span:last-child {
  cursor: pointer;
  color: #ff2b45;
}

.el-icon-plus {
  color: #ddd;
  line-height: 78px;
}

.errorMsg {
  font-size: 12px;
  color: red;
  padding-left: 10px;
  vertical-align: middle;
}
.wisdomSubmit :deep(.el-scrollbar__view) {
  height: 100% !important;
}
</style>
